export default
{
  "proj_desc": "众所周知，开源软件（OSS）对于软件产业有着十分巨大的影响力。这些虚拟的软件项目对于将不同地域、不同语言、不同时区的开发者聚集在了一起。过去十年左右，开源项目已经被广泛的采用和接纳，不仅有大量的志愿者参与了开源项目，而且许多公司也开始参与开源项目的开发。",
  "proj_desc_2": "这里写点说明这里写点说说吗 这里写点说明这里写点说说吗 这里写点说明这里写点说说吗 这里写点说明这里写点说说吗 这里写点说明这里写点说说吗 这里写点说明这里写点说说",
  "proj_items": [
    {
      "name": "公司在开源社区中的合作",
      "desc": "公司在开源软件的开发中已经占据了十分重要的地位。使用了社交网络方法，可视化的展示了公司在开源社区中的合作情况、合作模式以及合作影响。",
      "backgroundImage": "/img/p1.jpg",
      "main_color": "indigo-500",
      "linkto": "/comp-coop"
    },
    {
      "name": "开源社区中的公司参与模式",
      "desc": "需要补充描述",
      "backgroundImage": "/img/p4.jpg",
      "main_color": "indigo-500",
      "linkto": "/dev-participate"
    },
    {
      "name": "开源社区中的公司流失",
      "desc": "需要补充描述",
      "backgroundImage": "/img/p2.jpg",
      "main_color": "indigo-500",
      "linkto": "/comp-leave"
    },
    {
      "name": "开源社区中的开发者流失",
      "desc": "需要补充描述",
      "backgroundImage": "/img/p3.jpg",
      "main_color": "indigo-500",
      "linkto": "/dev-leave"
    }
  ]
}
